import * as RadixTooltip from '@radix-ui/react-tooltip';
import React, { PropsWithChildren } from 'react';

import clsxm from '@/lib/clsxm';

export interface IProps {
  text: string;
  position?: 'top' | 'right' | 'bottom' | 'left';
  className?: string;
}

const Tooltip: React.FC<PropsWithChildren<IProps>> = ({
  children,
  text,
  position = 'top',
  className,
}) => {
  return (
    <RadixTooltip.Provider>
      <RadixTooltip.Root delayDuration={0}>
        <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
        <RadixTooltip.Portal>
          <RadixTooltip.Content
            side={position}
            align='center'
            className={clsxm(
              'flex w-full items-center justify-center rounded-lg bg-black px-2 py-[5px] text-s text-white',
              className
            )}
          >
            {text}
            <RadixTooltip.Arrow />
          </RadixTooltip.Content>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  );
};

export default Tooltip;
